// components/SearchInput/index.tsx
import React, { useEffect, useRef } from "react";
import styles from "./index.module.scss";
import searchIcon from "../../../assets/images/search.svg";
import clearIcon from "../../../assets/images/close-icon.svg";
import { Tooltip } from "@mui/material";
import filter from "../../../assets/images/filter.svg";
import appliedFilter from "../../../assets/images/filterApplied.svg";
import sortIcon from "../../../assets/images/sort-icon.svg";
import arrowUp from "../../../assets/images/arrow-up.svg";
import arrowDown from "../../../assets/images/down-arrow.svg";
import { ref } from "yup";

interface SortState {
  sortKey: string;
  sortOrder: "asc" | "desc";
}

interface SearchInputProps {
  searchText: string;
  searchValue: { open: boolean; value: string };
  setSearchText: (text: string) => void;
  setFinalSearchText: (text: string) => void;
  handleSearch: (query: string) => void;
  setSearchValue: (value: { value: string; open: boolean }) => void;
  setPaginationProps: (fn: (prev: any) => any) => void;
  isFilterApplied: boolean;
  setIsOpenFilter: (value: boolean) => void;
  isOpenFilter: boolean;
  handleSort: (sortKey: string | boolean) => void;
  isSortDropdownOpen: boolean;
  setIsSortDropdownOpen: (value: boolean) => void;
  sortState: SortState;
}

const SearchInput: React.FC<SearchInputProps> = ({
  searchText,
  searchValue,
  setSearchText,
  setFinalSearchText,
  handleSearch,
  setSearchValue,
  setPaginationProps,
  isFilterApplied = false,
  setIsOpenFilter,
  isOpenFilter,
  handleSort,
  sortState,
  isSortDropdownOpen,
  setIsSortDropdownOpen,
}) => {
  // Generated by Copilot
  const dropdownRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!isSortDropdownOpen) return;
    const handleClickOutside = (event: MouseEvent) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
        setIsSortDropdownOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [isSortDropdownOpen]);
 

  const sortOptions = [
    { label: "Name", value: "fullName" },
    { label: "Age", value: "dob" },
    { label: "Registration Date", value: "registrationDate" },
    { label: "RM Rating", value: "averageRating" },
  ];
  return (
    <div className={styles.searchContainer}>
      {searchValue.open && (
        <div className={styles.search} data-testid="search-container">
          <input
            type="text"
            className={styles.searchInput}
            autoFocus
            value={searchText}
            placeholder="Search seeker with name"
            onChange={(e) => {
              setSearchText(e.target.value);
              if (e.target.value === "") {
                handleSearch("");
                setPaginationProps((prev: any) => ({
                  ...prev,
                  currentPage: 1,
                }));
              }
            }}
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                handleSearch(e.currentTarget.value);
                setPaginationProps((prev: any) => ({
                  ...prev,
                  currentPage: 1,
                }));
              }
            }}
            data-testid="search-input"
          />
          {searchText && (
            <button
              className={styles.clearIcon}
              onClick={() => {
                setSearchText("");
                setFinalSearchText("");
                handleSearch("");
                setPaginationProps((prev: any) => ({
                  ...prev,
                  currentPage: 1,
                }));
              }}
              data-testid="clear-button"
            >
              <img src={clearIcon} alt="clear" data-testid="clear-icon" />
            </button>
          )}
        </div>
      )}
      <Tooltip title="Search" arrow>
        <button className={styles.searchIcon} data-testid="search-button">
          <img
            src={searchIcon}
            alt="search"
            data-testid="search-icon"
            onClick={() =>
              setSearchValue({ value: "", open: !searchValue.open })
            }
          />
        </button>
      </Tooltip>
      <Tooltip title="Filter" arrow>
        <img
          src={isFilterApplied ? appliedFilter : filter}
          alt="toggle dropdown"
          className={styles.filterIcon}
          onClick={() => {
            setIsOpenFilter(!isOpenFilter);
          }}
        />
      </Tooltip>
      <div className={styles.sortContainer}>
        <Tooltip title="Sort" arrow>
          <>
            <img
              src={sortIcon}
              alt="sort icon"
              className={styles.filterIcon}
             
              onClick={() => setIsSortDropdownOpen(!isSortDropdownOpen)}
            />
            {sortState.sortKey != "" && <sup className={styles.blueDot}></sup>}
          </>
        </Tooltip>
        {isSortDropdownOpen && (
          <div className={styles.dropdownMenu}>
            {sortOptions.map((option) => (
              <div
                key={option.value}
                className={styles.dropdownItem}
                onClick={() => handleSort(option.value)}
              >
                <span className={styles.optionName}>{option.label}</span>
                <img
                  src={sortState.sortOrder === "desc" ? arrowDown : arrowUp}
                  alt="sort"
                  className={`${styles.sortArrow} ${
                    sortState.sortKey === option.value ? styles.visible : ""
                  } 
                    `}
                />
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default SearchInput;
